import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-error-screen',
    templateUrl: './error-screen.component.html',
    styleUrls: ['./error-screen.component.scss']
})
export class ErrorScreenComponent {
    @Input() errorMessage: string = 'Login failed due to a server issue. Please try again.';
    @Input() errorCode?: string = '500';

    retry() {
        window.location.reload();
    }
}
